import { apiClient, unwrap } from '@services/api';
import type { Product, SearchResult } from '@/types';

export const searchService = {
  async search(query: string): Promise<SearchResult> {
    const res = await apiClient.get<SearchResult>('/search', { params: { q: query } });
    return unwrap(res);
  },

  async searchProducts(query: string, wholesalerId?: string): Promise<Product[]> {
    const res = await apiClient.get<Product[]>('/search/products', {
      params: { q: query, wholesalerId },
    });
    return unwrap(res);
  },
};
